<template>
  <nav aria-label="paginacija" class="pagination_wrapper">
    <div class="pagination">

      <a class="pagination_link" v-if="pagination.current_page > 1" href="javascript:void(0)" aria-label="Prethodna strana"
        v-on:click.prevent="changePage(pagination.current_page - 1)">
        <span aria-hidden="true">«</span>
      </a>

      <a class="pagination_link" v-if="!checkFirstValue()" href="javascript:void(0)" v-on:click.prevent="changePage(1)">
        <span class="sr-only">Strana</span> 1 </a>

      <p v-if="!checkFirstTwoValue()" aria-hidden="true">
        <span>...</span>
      </p>

      <template v-for="page in pagesNumber">
        <p v-if="page == pagination.current_page" aria-current="page" aria-label="Trenutna strana"><span class="sr-only">Strana</span> {{ page }}</p>
        <a class="pagination_link" v-else href="javascript:void(0)" v-on:click.prevent="changePage(page)"><span class="sr-only">Strana</span> {{ page }}</a>
      </template>
      <!--<a v-for="page in pagesNumber" :key="page" :class="{'aria-current=page': page == pagination.current_page}" href="javascript:void(0)" v-on:click.prevent="changePage(page)">{{ page }}</a>-->

      <p v-if="!checkLastValue()" aria-hidden="true">
        <span>...</span>
      </p>

      <p class="pagination_link" v-if="!checkLastValue()">
        <a href="javascript:void(0)" v-on:click.prevent="changePage(pagination.last_page)"><span class="sr-only">Strana</span> {{
          pagination.last_page
          }}</a>
      </p>

      <a class="pagination_link" v-if="pagination.current_page < pagination.last_page" href="javascript:void(0)"
        aria-label="Naredna strana" v-on:click.prevent="changePage(pagination.current_page + 1)">
        <span aria-hidden="true">»</span>
      </a>

    </div>
  </nav>
</template>

<script>
export default{
  props: {
    pagination: {
      required: true
    },
    offset: {
      type: Number,
      default: 2
    }
  },
  computed: {
    pagesNumber() {
      if (!this.pagination.to) {
        return [];
      }
      let from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      let to = from + (this.offset * 2);
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      let pagesArray = [];
      for (let page = from; page <= to; page++) {
        pagesArray.push(page);
      }
      return pagesArray;
    }
  },
  methods : {
    changePage(page) {
      this.pagination.current_page = page;
      this.$emit('paginate');
    },
    checkLastValue(){
      let last_page = this.pagination.last_page;
      return this.pagesNumber.includes(last_page);
    },
		checkFirstValue(){
			return this.pagesNumber.includes(1)
		},
    checkFirstTwoValue(){
      let first = this.pagesNumber.includes(1);
      if (first === false) {
        return this.pagesNumber.includes(2);
      }
      return first;
    }
  }
}
</script>